import React, { useEffect } from 'react';
import { Phone, CheckCircle, Clock, MapPin, Shield } from 'lucide-react';
import { ContactSection } from '../components/ContactSection';
import { businessInfo } from '../mockData';

export const BookInspectionPage = () => {
  useEffect(() => {
    document.title = "Book Free Roof Inspection | Dezire Metal Roofing Sydney";
  }, []);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/g9jljj6s_13506d2d-2490-4647-bf63-c0b287e8cac5.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-block mb-4 px-4 py-2 bg-primary/20 border border-primary/30 rounded-full">
              <span className="text-primary font-semibold">100% Free - No Obligation</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Book Your <span className="text-primary">Free Roof Inspection</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Get a comprehensive roof assessment from Sydney's trusted metal roofing experts. We'll identify any issues and provide honest recommendations.
            </p>
            
            {/* Benefits */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              <div className="flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
                <CheckCircle className="w-5 h-5 text-primary" />
                <span className="text-white font-medium">Free Assessment</span>
              </div>
              <div className="flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
                <Clock className="w-5 h-5 text-primary" />
                <span className="text-white font-medium">Same Day Service</span>
              </div>
              <div className="flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg">
                <Shield className="w-5 h-5 text-primary" />
                <span className="text-white font-medium">Expert Advice</span>
              </div>
            </div>

            {/* Quick Call CTA */}
            <a
              href="/call"
              className="inline-flex items-center space-x-3 bg-primary hover:bg-accent text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all"
            >
              <Phone className="w-6 h-6" />
              <span>Call Now: {businessInfo.phone}</span>
            </a>
          </div>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              What's Included in Your <span className="text-primary">Free Inspection</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                "Complete roof surface examination",
                "Gutter and downpipe assessment",
                "Flashing and seal inspection",
                "Structural integrity check",
                "Leak detection analysis",
                "Photo documentation",
                "Written inspection report",
                "No-obligation quote"
              ].map((item, index) => (
                <div key={index} className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg">
                  <CheckCircle className="w-6 h-6 text-primary flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactSection />

      {/* Trust Indicators */}
      <section className="py-12 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-primary mb-2">24/7</div>
              <p className="text-gray-300">Emergency Service Available</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">100%</div>
              <p className="text-gray-300">Free Inspection & Quote</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-primary mb-2">Local</div>
              <p className="text-gray-300">Sydney Based & Operated</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
